import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const avatarModalStatusSelector = (state: RootState): boolean => state.avatarModal.status;
